import { enableSave } from "./enableSave";
import ITemperatures from "../interfaces/Temperatures";
import { TCategoryProductSheet } from "../../../types/product";
import { BRANDS } from "../../../types/brands";

interface TemperatureEnableObject {
  isRequired: boolean;
  temperatures: ITemperatures;
}

const hasSpecialCharacters = (value: string) =>
  /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(value);

export const isSaveButtonEnabled = (
  temperatureObj: TemperatureEnableObject[] = [],
  productSheet: TCategoryProductSheet,
  selectedBrand: string,
) => {
  if (selectedBrand === BRANDS.TH && productSheet.display) {
    if (
      productSheet.shelfLife <= 0 ||
      productSheet.shelfLifeUnit <= 0 ||
      !productSheet.unitsOfMeasure.units.length ||
      !productSheet.unitsOfMeasure.default
    )
      return false;
  }

  if (temperatureObj.every(({ isRequired }) => !isRequired)) return true;

  return temperatureObj.every(
    ({ temperatures, isRequired }) =>
      enableSave(temperatures, isRequired) === true,
  );
};
